<template>
  <div class="setting-view">
    <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
      <el-tab-pane label="个人设置" name="first">
        <div class="content">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="" prop="userImg">
              <el-upload
                class="avatar-uploader"
                :action="actionUrl"
                :show-file-list="false"
                :data="imageData"
                :on-success="handleAvatarSuccess"
                name="file"
                :before-upload="beforeAvatarUpload">
                <img v-if="ruleForm.userImg" :src="ruleForm.userImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!-- https://jsonplaceholder.typicode.com/posts/ -->
            </el-form-item>
            <el-form-item label="用户名">
              {{userName}}
            </el-form-item>
            <el-form-item label="昵称" prop="nickname">
              <el-input v-model="ruleForm.nickname"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="mailbox">
              <el-input type="email" v-model="ruleForm.mailbox"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="密码设置" name="second">
        <div class="content">
          <el-form :model="passwordForm" status-icon :rules="rulesPassword" ref="passwordForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="beforePassword">
              <el-input type="password" v-model="passwordForm.beforePassword"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="passwordOne">
              <el-input type="password" v-model="passwordForm.passwordOne"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="passwordTwo">
              <el-input type="password" v-model="passwordForm.passwordTwo"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="submitForm('passwordForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: '',
  data () {
    var checkMailbox = (rule, value, callback) => {
      var regex = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
      if (!value) {
        return callback(new Error('邮箱不能为空！'))
      } else if (!regex.test(value)) {
        callback(new Error('您输入的电子邮件地址不合法！'))
      } else {
        callback()
      }
    }
    var checkNickname = (rule, value, callback) => {
      var uPattern = /^[a-zA-Z0-9_-]{4,16}$/
      if (value === '' || value === null) {
        callback(new Error('昵称不能为空！'))
      } else if (!uPattern.test(value)) {
        callback(new Error('昵称：包含4到16位的字母，数字，下划线，减号'))
      } else {
        callback()
      }
    }
    var checkBeforePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('原密码不能为空！'))
      } else {
        callback()
      }
    }
    var checkPasswordOne = (rule, value, callback) => {
      const regex = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/
      if (value === '') {
        callback(new Error('密码不能为空！'))
      } else if (!regex.test(value)) {
        callback(new Error('密码长度8~16位数字、字母、字符至少包含两种！'))
      } else {
        callback()
      }
    }
    var checkPasswordTwo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.passwordOne) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      activeName2: 'first',
      imageUrl: '',
      userName: '',
      actionUrl: this.$allUrl.updateCustomerHeadIcon,
      imageData: {
        userId: ''
      },
      ruleForm: {
        userImg: '',
        nickname: '',
        mailbox: ''
      },
      rules: {
        nickname: [
          { validator: checkNickname, trigger: 'blur' }
        ],
        mailbox: [
          { validator: checkMailbox, trigger: 'blur' }
        ]
      },
      passwordForm: {
        beforePassword: '',
        passwordOne: '',
        passwordTwo: ''
      },
      rulesPassword: {
        beforePassword: [
          { validator: checkBeforePassword, trigger: 'blur' }
        ],
        passwordOne: [
          { validator: checkPasswordOne, trigger: 'blur' }
        ],
        passwordTwo: [
          { validator: checkPasswordTwo, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === 'passwordForm') {
            this.updatePassword()
          } else {
            this.updateCustomer()
          }
        } else {
          return false
        }
      })
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    handleAvatarSuccess (res, file) {
      this.ruleForm.userImg = URL.createObjectURL(file.raw)
      const user = this.$store.state.userMsg
      user.userIcon = res.data
      this.updateUser(user)
    },
    beforeAvatarUpload (file) {
      // const isJPG = file.type === 'image/jpeg'
      // const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
    },
    updatePassword () { // 密码修改
      const userId = this.$store.state.userMsg.id
      // const password = this.passwordForm.beforePassword
      const password = this.$md5(this.passwordForm.beforePassword)
      // const newPassword = this.passwordForm.passwordOne
      const newPassword = this.$md5(this.passwordForm.passwordOne)
      const par = `?userId=${userId}&password=${password}&newPassword=${newPassword}`
      this.$get(this.$allUrl.updatePassword + par).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '恭喜您，修改成功！',
            type: 'success'
          })
          this.$refs['passwordForm'].resetFields()
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    updateCustomer () { // 修改用户信息
      const userId = this.$store.state.userMsg.id
      const nickName = this.ruleForm.nickname
      const email = this.ruleForm.mailbox
      const par = `?userId=${userId}&nickName=${nickName}&email=${email}`
      this.$get(this.$allUrl.updateCustomer + par).then(res => {
        if (res.code === '0') {
          this.$message({
            message: '恭喜您，修改成功！',
            type: 'success'
          })
          let user = this.$store.state.userMsg
          user.nickName = nickName
          user.email = email
          this.updateUser(user)
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    updateUser (obj) {
      window.sessionStorage.setItem('ysUserMsg', JSON.stringify(obj))
      this.$store.dispatch('update_userMsg', obj)
    }
  },
  mounted () {
    const userMsg = this.$store.state.userMsg
    const imgAdmin = this.$allUrl.imgAdmin
    this.imageData.userId = this.$store.state.userMsg.id
    const userImg = imgAdmin + userMsg.userIcon
    const nickname = userMsg.nickName
    const mailbox = userMsg.email
    this.userName = userMsg.userName
    this.ruleForm = {
      userImg: userImg,
      nickname: nickname,
      mailbox: mailbox
    }
  }
}
</script>
<style lang="less" scoped>
  .setting-view{
    padding-top: 40px;
    .content{
      width: 400px;
      margin: auto;
    }
  }
</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF !important;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Settings/settingsuser.vue


// WEBPACK FOOTER //
// src/components/Personal/Settings/settingsuser.vue